import React from 'react'
import Image from 'next/image'

import MedShrLogo from '/public/static/media/svg/awards/Student_Ambassador.svg'

interface Props {
  id?: string
  title?: string
  className?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
  width?: number
}

const ClinicalLeaderBadge = ({
  id = 'icon-editor-badge',
  title = 'Student Ambassador ',
  className,
  onClick,
  width,
}: Props) => {
  return (
    <Image
      id={id}
      alt={title}
      title={title}
      src={MedShrLogo}
      className={className}
      width={width}
      height={width}
      onClick={onClick}
    />
  )
}

export default ClinicalLeaderBadge
